import SplitFareDialog from './SplitFareDialog';

export default SplitFareDialog;
